import type { Locale } from '../i18n/messages';

export type ContentParityMap = Readonly<Record<string, string>>;
type ContentParityLocale = Exclude<Locale, 'en'>;

const maps = new Map<ContentParityLocale, ContentParityMap>();

export class ContentParityTranslationsUnavailableError extends Error {
  readonly locale: ContentParityLocale;

  constructor(locale: ContentParityLocale) {
    super(`Content-parity translations are unavailable for ${locale}`);
    this.name = 'ContentParityTranslationsUnavailableError';
    this.locale = locale;
  }
}

export function registerContentParityTranslations(
  locale: ContentParityLocale,
  translations: ContentParityMap,
): void {
  maps.set(locale, translations);
}

export function getContentParityTranslations(locale: Locale): ContentParityMap | undefined {
  return locale === 'en' ? undefined : maps.get(locale);
}
